import { useApp } from "@/context/AppContext";

export function Logo({ className = "h-12 w-12", testid }) {
  const { logoUrl } = useApp();
  return (
    <div className={`flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-white p-1 ${className}`} data-testid={testid}>
      <img src={logoUrl} alt="Logo" className="block h-auto max-h-full w-auto max-w-full" />
    </div>
  );
}
